import React from 'react';
import Slider from "react-slick";
import './testimonial.css';

const Testimonial = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false
  };

  return (
    <section className="testimonial-section">
        <h1>
        <span>Testimonial</span> Happy Travelers
      </h1>
      
      <div className="testimonial-container">
        <div className="testimonial-text">
          <Slider {...settings}>
            <div className="testimonial-quote">
              <p>
              "Traveling with Around the Globe was a revelation. From the moment I contacted them, their attention to detail was impeccable. The personalized itinerary they crafted exceeded all my expectations, and every moment of my journey felt like a dream come true. Their expert guides provided insightful commentary and made me feel like a VIP everywhere we went. Thanks to Around the Globe, I returned home with memories that will last a lifetime."


              </p>
              <div className="testimonial-author">
                <div className="name">Anil Bhardwaj, Delhi</div>
                {/* <div className="designation">University Student</div> */}
              </div>
            </div>
            <div className="testimonial-quote">
              <p>
              "Booking with Around the Globe was the best decision I made for my vacation. Their attention to detail and personalized service made me feel like a VIP throughout the entire journey. From the moment I arrived at my destination to the day I left, everything was seamless and stress-free. The itinerary they crafted for me perfectly balanced adventure and relaxation, leaving me with memories I'll cherish forever. Around the Globe truly exceeded all my expectations, and I can't wait to book my next adventure with them!"


              </p>
              <div className="testimonial-author">
                <div className="name">Stacy McCullen, Australia</div>
                {/* <div className="designation">University Student</div> */}
              </div>
            </div>
            <div className="testimonial-quote">
              <p>
              "Booking with Around the Globe was seamless. From start to finish, they listened to my preferences and crafted a personalized itinerary that exceeded my expectations. Every detail was meticulously planned, from the accommodations to the guided tours. The local guides were knowledgeable and passionate, adding depth to my travel experience. Around the Globe truly made my journey unforgettable, and I can't wait to book with them again for my next adventure!"


              </p>
              <div className="testimonial-author">
                <div className="name">Vishakha Menon, Mumbai</div>
                {/* <div className="designation">University Student</div> */}
              </div>
            </div>
            <div className="testimonial-quote">
              <p>
              "Around the Globe made unforgettable memories possible. They listened to my preferences and crafted a personalized itinerary that surpassed expectations. Every detail, from accommodations to guided tours, was meticulously planned. The knowledgeable and passionate local guides added depth to my experience. Thanks to Around the Globe, my journey was truly unforgettable, and I look forward to booking with them again."


              </p>
              <div className="testimonial-author">
                <div className="name">Manish Patel, Gujarat</div>
                {/* <div className="designation">University Student</div> */}
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default Testimonial;
